/* 2.5.0 search page (PROTO-2 se): the clear button in the search field, the rest of the matches when Shopify's
   results needed filtering, and the Guides rows. Results come from
   Shopify's search on submit; "+" is jp-set.js's [data-jp-set-add]. Guides: up to 3 articles or pages for the searched
   words from Shopify's own predictive search (section jp-predictive, Section Rendering API), as the prototype's rows
   (title, a "Guide" label, a chevron); the block stays hidden when there are none. The words are not stored or sent
   anywhere else. */
(function () {
  'use strict';
  var f = document.querySelector('.p2-se .se-f');
  if (f) {
    var q = f.querySelector('input[name="q"]'), x = f.querySelector('[data-se-clear]');
    if (q && x) {
      q.addEventListener('input', function () { x.hidden = !q.value; });
      x.addEventListener('click', function () { q.value = ''; x.hidden = true; q.focus(); });
    }
  }
  /* Shopify returned non-matches too (the theme drops them, jp-search-match): read the remaining result pages through
     this section (Section Rendering API) and add their matches, so the list and its count are complete */
  var grid = document.querySelector('.p2-se #grid[data-drop]');
  if (grid && +grid.getAttribute('data-drop') > 0 && grid.getAttribute('data-next') && window.fetch && window.DOMParser) (function () {
    var sid = grid.getAttribute('data-sid'), n = grid.querySelectorAll('.se-d').length, hops = 0, seen = {};
    [].forEach.call(grid.querySelectorAll('.se-d[data-h]'), function (c) { seen[c.getAttribute('data-h')] = 1; });
    function done() {
      var e = document.querySelector('.p2-se [data-se-n]'), sx = document.querySelector('.p2-se [data-se-s]'), pg = document.querySelector('.p2-se [data-se-pages]');
      if (e) e.textContent = n; if (sx) sx.textContent = n === 1 ? '' : 's'; if (pg) pg.hidden = true;
    }
    function next(url) {
      var u = new URL(url, location.href); u.searchParams.set('section_id', sid);
      fetch(u.pathname + u.search, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (t) {
        var g = new DOMParser().parseFromString(t, 'text/html').querySelector('#grid[data-drop]'); if (!g) throw new Error('grid');
        [].forEach.call(g.querySelectorAll('.se-d'), function (c) { var h = c.getAttribute('data-h'); if (seen[h]) return; seen[h] = 1; grid.appendChild(document.adoptNode(c)); n++; });
        var nx = g.getAttribute('data-next'); hops++;
        if (nx && hops < 6) next(nx); else done();
        document.dispatchEvent(new CustomEvent('jp:grid-more', { detail: { added: n } }));
      }).catch(function () {});
    }
    next(grid.getAttribute('data-next'));
  })();

  var strip = document.querySelector('.p2-se [data-jp-guides]'), box = strip && strip.querySelector('.se-gd');
  var words = strip && (strip.getAttribute('data-q') || '').trim();
  if (!box || !words || words.length < 2 || !window.fetch || !window.DOMParser) return;
  var CHEV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
  fetch(base + '?q=' + encodeURIComponent(words) + '&resources%5Btype%5D=article,page&resources%5Blimit%5D=3&resources%5Blimit_scope%5D=each&section_id=jp-predictive',
    { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
    .then(function (r) { if (!r.ok) throw new Error('suggest ' + r.status); return r.text(); })
    .then(function (html) {
      var g = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-jp-suggest-group="guides"]');
      if (!g) return;
      Array.prototype.forEach.call(g.querySelectorAll('a[href]'), function (a) {
        var row = document.createElement('a'), t = document.createElement('span'), k = document.createElement('small');
        row.href = a.getAttribute('href'); t.textContent = a.textContent.trim(); k.textContent = 'Guide';
        t.appendChild(k); row.appendChild(t); row.insertAdjacentHTML('beforeend', CHEV); box.appendChild(row);
      });
      strip.hidden = !box.children.length;
    }).catch(function () {});
})();
